import React from 'react';

export default function InboxPage({ st = {}, setSt, notify, setTab }) {
  const notes = (st.notes || []).slice().sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));

  const deleteNote = (id) => {
    setSt(p => ({ ...p, notes: (p.notes || []).filter(n => n.id !== id) }));
    notify && notify('note removed');
  };

  const fmtDate = (iso) => {
    if (!iso) return '';
    try {
      return new Date(iso + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch { return iso; }
  };

  return (
    <>
    <style>{'.inbox-page{max-width:680px;margin:0 auto;padding:var(--sp4) var(--sp4) var(--sp12);font-family:var(--sans);}@media(max-width:768px){.inbox-page{padding-bottom:calc(var(--bot-nav-h,56px)+var(--sp10)+var(--safe-bottom,0px));}}' }</style>
    <div className="inbox-page">
      {/* Header */}
      <div style={{ paddingTop: 'var(--sp4)', marginBottom: 'var(--sp5)' }}>
        <h1 style={{
          fontSize: 28, fontWeight: 300, color: 'var(--ink)',
          letterSpacing: '-0.3px', lineHeight: 1.15, margin: 0,
        }}>
          inbox
          <span style={{ color: 'var(--t3)', fontWeight: 300 }}> · </span>
          <span style={{ color: 'var(--accent)', fontSize: 22 }}>notes</span>
        </h1>
        <div style={{ fontSize: 11, color: 'var(--t3)', marginTop: 6, letterSpacing: '0.03em' }}>
          captured from conversations with mylo
        </div>
      </div>

      {notes.length === 0 ? (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          padding: 'var(--sp12) 0', gap: 'var(--sp3)', textAlign: 'center',
        }}>
          <div style={{ fontSize: 32, opacity: 0.15, marginBottom: 4 }}>◎</div>
          <div style={{ fontSize: 14, color: 'var(--t2)', fontWeight: 400 }}>no notes yet</div>
          <div style={{ fontSize: 13, color: 'var(--t3)', lineHeight: 1.6, maxWidth: 260 }}>
            tell mylo a thought, idea, or observation — anything you don't want to lose.
          </div>
          <button
            onClick={() => setTab && setTab('ask')}
            style={{
              marginTop: 8, background: 'var(--s1)',
              border: '0.5px solid var(--b2)', borderRadius: 'var(--r2)',
              padding: '9px 18px', fontFamily: 'var(--sans)', fontSize: 13,
              color: 'var(--t2)', cursor: 'pointer',
              WebkitTapHighlightColor: 'transparent',
            }}
          >open mylo →</button>
        </div>
      ) : (
        <div style={{
          background: 'var(--s1)', border: '0.5px solid var(--b1)',
          borderRadius: 'var(--r3)', overflow: 'hidden',
        }}>
          {notes.map((note, i) => (
            <div key={note.id} style={{
              display: 'flex', alignItems: 'flex-start', gap: 12,
              padding: '12px 16px',
              borderBottom: i < notes.length - 1 ? '0.5px solid var(--b1)' : 'none',
            }}>
              {/* Date */}
              <div style={{
                fontFamily: 'var(--sans)', fontSize: 11, color: 'var(--t4)',
                flexShrink: 0, paddingTop: 2, minWidth: 40,
              }}>
                {fmtDate(note.createdAt)}
              </div>

              {/* Text */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontSize: 13, color: 'var(--ink)', lineHeight: 1.55,
                  wordBreak: 'break-word',
                }}>{note.text}</div>
                {note.tags && note.tags.length > 0 && (
                  <div style={{ display: 'flex', gap: 4, marginTop: 6, flexWrap: 'wrap' }}>
                    {note.tags.map(tag => (
                      <span key={tag} style={{
                        fontSize: 10, color: 'var(--t3)',
                        background: 'var(--s2)', border: '0.5px solid var(--b1)',
                        borderRadius: 'var(--r)', padding: '2px 6px',
                      }}>{tag}</span>
                    ))}
                  </div>
                )}
              </div>

              {/* Delete */}
              <button
                onClick={() => deleteNote(note.id)}
                style={{
                  background: 'transparent', border: 'none',
                  color: 'var(--t4)', cursor: 'pointer',
                  fontSize: 16, padding: '0 2px', flexShrink: 0,
                  WebkitTapHighlightColor: 'transparent',
                  transition: 'color 0.1s',
                }}
                onMouseEnter={e => { e.currentTarget.style.color = 'var(--red)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--t4)'; }}
                aria-label="delete note"
              >×</button>
            </div>
          ))}
        </div>
      )}
    </div>
    </>
  );
}
